import React, { Component } from "react";
import "./TrendChart.css";
import per_poll_prediction from "../../store/predictions_per_poll.js";
import raw_polls_data from "../../store/raw_polls_data.js";
import Share from "../Share/Share";

import { event as currentEvent } from "d3-selection";

var d3 = Object.assign(
  {},
  require("d3-selection"),
  require("d3-transition"),
  require("d3-array"),
  require("d3-axis"),
  require("d3-shape"),
  require("d3-format"),
  require("d3-scale"),
  require("d3-time-format"),
  require("d3-svg-annotation"),
  require("d3-svg-legend"),
  require("d3-jetpack")
);

class TrendChart extends Component {
  componentDidMount() {
    this.setup();
  }

  componentDidUpdate(prevProps, prevState) {}

  setup() {
    this.visComponents = this.makeVisComponets(this.props);

    const { innerM } = this.visComponents;

    this.g = d3
      .select(this.svg)
      .append("g")
      .attr("transform", `translate(${innerM.left} ${innerM.top - 10})`);

    this.trend = this.g.append("g").classed("trend", true);
    this.polls = this.g.append("g").classed("polls", true);
    this.xAxis = this.g.append("g").classed("x-axis axis", true);
    this.yAxis = this.g.append("g").classed("y-axis axis", true);

    this.g5 = d3
      .select(this.svg2)
      .append("g")
      .attr("transform", `translate(${innerM.left} ${innerM.top - 10})`);

    this.trend5 = this.g5.append("g").classed("trend5", true);
    this.polls5 = this.g5.append("g").classed("polls5", true);
    this.xAxis5 = this.g5.append("g").classed("x-axis axis", true);
    this.yAxis5 = this.g5.append("g").classed("y-axis axis", true);

    this.tooltip = d3
      .select(".trend-chart")
      .append("div")
      .classed("tooltip", true)
      .style("opacity", 0);

    this.update();
  }

  makeVisComponets(props) {
    const { height, width } = props;
    const innerM = { top: 20, right: 120, bottom: 30, left: 40 },
      innerH = height - innerM.top - innerM.bottom,
      innerW = width - innerM.right - innerM.left,
      parsePredictionDate = d3.timeParse("%Y-%m-%d"),
      parsePollsDate = d3.timeParse("%d/%m/%Y");

    // Parse dates
    per_poll_prediction.forEach(d => {
      d.date = parsePredictionDate(d.date);
    });

    raw_polls_data.forEach(d => {
      d.date = parsePollsDate(d.date);
    });

    const parties = [
      "ACT",
      "Conservative",
      "Green",
      "Labour",
      "Mana",
      "Maori",
      "National",
      "New Zealand First",
      "United Future"
    ];

    // format for line chart
    const party_trend = parties.map(party => {
      return {
        party: party,
        values: per_poll_prediction.filter(d => d.party === party).map(d => {
          return {
            date: d.date,
            median: d.median
          };
        })
      };
    });

    party_trend.forEach(d => {
      (d.party = d.party),
        (d.latest = d.values[0].median),
        (d.date = d.values[0].date);
    });

    const xDomain = [
        d3.min(per_poll_prediction, d => d.date),
        d3.max(per_poll_prediction, d => d.date)
      ],
      yDomain = [d3.max(per_poll_prediction, d => d.median), 0],
      yDomain5 = [
        d3.max(per_poll_prediction.filter(d => d.median < 4), d => d.median),
        0
      ],
      xScale = d3
        .scaleTime()
        .domain(xDomain)
        .range([10, innerW]),
      yScale = d3
        .scaleLinear()
        .domain(yDomain)
        .range([10, innerH]),
      yScale5 = d3
        .scaleLinear()
        .domain(yDomain5)
        .range([10, innerH]);

    const line = d3
      .line()
      .x(d => xScale(d.date))
      .y(d => yScale(d.median))
      .curve(d3.curveStep);

    const line5 = d3
      .line()
      .x(d => xScale(d.date))
      .y(d => yScale5(d.median))
      .curve(d3.curveStep);

    const colorScale = d3
      .scaleOrdinal()
      .domain([
        "Conservative",
        "Mana",
        "United Future",
        "ACT",
        "Maori",
        "Green",
        "New Zealand First",
        "Labour",
        "National",
        "TOP"
      ])
      .range([
        "#00AEEF",
        "#770808",
        "#501557",
        "#FDE401",
        "#EF4A42",
        "#098137",
        "#000000",
        "#D82A20",
        "#00529F",
        "#151A61"
      ]);

    return {
      xScale,
      yScale,
      innerH,
      innerW,
      innerM,
      line,
      colorScale,
      raw_polls_data,
      party_trend,
      yScale5,
      line5
    };
  }

  update() {
    this.renderCircles();
    this.renderTrendLine();
    this.renderAxes();
    this.renderSideLabels();
    this.renderCircles5();
    this.renderTrendLine5();
    this.renderAxes5();
    this.renderSideLabels5();
    this.renderTopLabel();
  }

  renderCircles() {
    const { raw_polls_data, xScale, yScale, colorScale } = this.visComponents;

    const formatDate = d3.timeFormat("%d %B %y");

    const bindCircles = this.polls
      .selectAll("circle")
      .data(raw_polls_data.filter(d => d.median > 4), d => d.party + d.date);

    const enterCircles = bindCircles
      .enter()
      .append("circle")
      .at({
        class: d =>
          "circles" + " party-" + d.party.replace(/\s/g, "").toLowerCase(),
        fill: d => colorScale(d.party),
        cx: d => xScale(d.date),
        cy: d => yScale(d.median),
        party: d => d.party,
        r: 5,
        opacity: 0.2
      })
      .on("mouseover", d => {
        this.tooltip
          .transition()
          .duration(150)
          .style("opacity", 1);

        d3
          .selectAll(".line")
          .transition()
          .duration(100)
          .st("opacity", 0.1);
        d3
          .selectAll(".circles")
          .transition()
          .duration(100)
          .st("opacity", 0.05);

        d3
          .selectAll(".line.party-" + d.party.replace(/\s/g, "").toLowerCase())
          .transition()
          .duration(1000)
          .st("opacity", 1);

        d3
          .selectAll(
            ".circles.party-" + d.party.replace(/\s/g, "").toLowerCase()
          )
          .transition()
          .duration(1000)
          .st("opacity", 0.4);

        this.tooltip
          .html(
            "<b>" +
              d.party +
              "</b>" +
              "<br/>" +
              "<small>" +
              "Date: " +
              formatDate(d.date) +
              "</small>" +
              "<br/>" +
              "Party Vote: " +
              d.median +
              "%" +
              "<br/>" +
              "<small>" +
              d.poll +
              "</small>"
          )
          .style("left", currentEvent.pageX - 100 + "px")
          .style("top", currentEvent.pageY - 150 + "px");
      })
      .on("mouseout", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(500)
          .st("opacity", 1);

        d3
          .selectAll(".circles")
          .transition()
          .duration(500)
          .st("opacity", 0.2);

        this.tooltip
          .transition()
          .duration(100)
          .style("left", currentEvent.pageX - 100 + "px")
          .style("top", currentEvent.pageY - 150 + "px")
          .style("opacity", 0);
      });

    bindCircles.merge(enterCircles);
  }

  renderTrendLine() {
    const { party_trend, line, colorScale } = this.visComponents;

    const party_trends = this.trend
      .selectAll("path")
      .data(party_trend, d => d.party);

    party_trends
      .enter()
      .append("svg:path")
      .attr("class", function(d) {
        return "line" + " party-" + d.party.replace(/\s/g, "").toLowerCase();
      })
      .attr("d", d => line(d.values))
      .attr("stroke", d => colorScale(d.party));
  }

  renderAxes() {
    const { xScale, yScale, innerH, innerW } = this.visComponents;

    const xAxis = d3
      .axisBottom(xScale)
      .tickSizeInner(0)
      .ticks(4);

    this.xAxis.attr("transform", `translate(0, ${innerH + 10} )`).call(xAxis);

    const yAxis = d3
      .axisLeft(yScale)
      .tickSizeInner(-innerW)
      .tickFormat(d3.format(".0s"))
      .ticks(3);

    this.yAxis.call(yAxis);
  }

  renderSideLabels() {
    const {
      xScale,
      yScale,
      innerH,
      innerW,
      party_trend,
      colorScale
    } = this.visComponents;

    const label_data = party_trend.filter(d => d.latest > 3);

    this.g
      .selectAll("text")
      .data(label_data.filter(d => d.party === "National"), d => d.party)
      .enter()
      .append("text")
      .at({
        d: d => d.party,
        x: d => xScale(d.date) + 14,
        y: d => yScale(d.latest) + 7,
        fill: d => colorScale(d.party),
        "font-family": "sans-serif",
        "font-size": "11px",
        class: "party-name"
      })
      .text(d => d.party)
      .on("mouseover", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(100)
          .st("opacity", 0.1);
        d3
          .selectAll(".circles")
          .transition()
          .duration(100)
          .st("opacity", 0.05);

        d3
          .selectAll(".line.party-" + d.party.replace(/\s/g, "").toLowerCase())
          .transition()
          .duration(1000)
          .st("opacity", 1);

        d3
          .selectAll(
            ".circles.party-" + d.party.replace(/\s/g, "").toLowerCase()
          )
          .transition()
          .duration(1000)
          .st("opacity", 0.4);
      })
      .on("mouseout", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(500)
          .st("opacity", 1);

        d3
          .selectAll(".circles")
          .transition()
          .duration(500)
          .st("opacity", 0.2);
      });

    this.trend
      .selectAll("text")
      .data(label_data.filter(d => d.party === "National"), d => d.party)
      .enter()
      .append("text")
      .at({
        x: d => xScale(d.date) + 14,
        y: d => yScale(d.latest) + 17,
        fill: d => colorScale(d.party),
        "font-family": "sans-serif",
        "font-size": "11px"
      })
      .text(d => d3.format(".2")(d.latest) + "%");

    this.g
      .selectAll("text")
      .data(label_data.filter(d => d.party === "Labour"), d => d.party)
      .enter()
      .append("text")
      .at({
        d: d => d.party,
        x: d => xScale(d.date) + 14,
        y: d => yScale(d.latest),
        fill: d => colorScale(d.party),
        "font-family": "sans-serif",
        "font-size": "11px",
        class: "party-name"
      })
      .text(d => d.party)
      .on("mouseover", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(100)
          .st("opacity", 0.1);
        d3
          .selectAll(".circles")
          .transition()
          .duration(100)
          .st("opacity", 0.05);

        d3
          .selectAll(".line.party-" + d.party.replace(/\s/g, "").toLowerCase())
          .transition()
          .duration(1000)
          .st("opacity", 1);

        d3
          .selectAll(
            ".circles.party-" + d.party.replace(/\s/g, "").toLowerCase()
          )
          .transition()
          .duration(1000)
          .st("opacity", 0.4);
      })
      .on("mouseout", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(500)
          .st("opacity", 1);

        d3
          .selectAll(".circles")
          .transition()
          .duration(500)
          .st("opacity", 0.2);
      });

    this.trend
      .selectAll("text")
      .data(label_data.filter(d => d.party === "Labour"), d => d.party)
      .enter()
      .append("text")
      .at({
        x: d => xScale(d.date) + 14,
        y: d => yScale(d.latest)+ 10,
        fill: d => colorScale(d.party),
        "font-family": "sans-serif",
        "font-size": "11px"
      })
      .text(d => d3.format(".2")(d.latest) + "%");

    this.g
      .selectAll("text")
      .data(
        label_data.filter(
          d => (d.party !== "National") & (d.party !== "Labour")
        ),
        d => d.party
      )
      .enter()
      .append("text")
      .at({
        d: d => d.party,
        x: d => xScale(d.date) + 4,
        y: d => yScale(d.latest) + 3,
        fill: d => colorScale(d.party),
        "font-family": "sans-serif",
        "font-size": "11px",
        class: "party-name"
      })
      .text(d => d.party)
      .on("mouseover", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(100)
          .st("opacity", 0.1);
        d3
          .selectAll(".circles")
          .transition()
          .duration(100)
          .st("opacity", 0.05);

        d3
          .selectAll(".line.party-" + d.party.replace(/\s/g, "").toLowerCase())
          .transition()
          .duration(1000)
          .st("opacity", 1);

        d3
          .selectAll(
            ".circles.party-" + d.party.replace(/\s/g, "").toLowerCase()
          )
          .transition()
          .duration(1000)
          .st("opacity", 0.4);
      })
      .on("mouseout", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(500)
          .st("opacity", 1);

        d3
          .selectAll(".circles")
          .transition()
          .duration(500)
          .st("opacity", 0.2);
      });

    this.trend
      .selectAll("text")
      .data(
        label_data.filter(
          d => (d.party !== "National") & (d.party !== "Labour")
        ),
        d => d.party
      )
      .enter()
      .append("text")
      .at({
        x: d => xScale(d.date) + 24,
        y: d => yScale(d.latest) + 12,
        fill: d => colorScale(d.party),
        "font-family": "sans-serif",
        "font-size": "11px"
      })
      .text(d => d3.format(".2")(d.latest) + "%");
  }

  renderTopLabel() {
    const { raw_polls_data, colorScale, xScale, yScale5 } = this.visComponents;

    const label_data = raw_polls_data.filter(d => d.party === "TOP");

  }

  renderCircles5() {
    const { raw_polls_data, xScale, yScale5, colorScale } = this.visComponents;

    const formatDate = d3.timeFormat("%d %B %y");

    const bindCircles = this.polls5
      .selectAll("circle")
      .data(raw_polls_data.filter(d => d.median < 3), d => d.party + d.date);

    const enterCircles = bindCircles
      .enter()
      .append("circle")
      .at({
        class: d =>
          "circles" + " party-" + d.party.replace(/\s/g, "").toLowerCase(),
        fill: d => colorScale(d.party),
        cx: d => xScale(d.date),
        cy: d => yScale5(d.median),
        party: d => d.party,
        r: 5,
        opacity: 0.2
      })
      .on("mouseover", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(100)
          .st("opacity", 0.1);
        d3
          .selectAll(".circles")
          .transition()
          .duration(100)
          .st("opacity", 0.05);

        d3
          .selectAll(".line.party-" + d.party.replace(/\s/g, "").toLowerCase())
          .transition()
          .duration(1000)
          .st("opacity", 1);

        d3
          .selectAll(
            ".circles.party-" + d.party.replace(/\s/g, "").toLowerCase()
          )
          .transition()
          .duration(1000)
          .st("opacity", 0.4);

        this.tooltip
          .transition()
          .duration(150)
          .style("opacity", 1);

        this.tooltip
          .html(
            "<b>" +
              d.party +
              "</b>" +
              "<br/>" +
              "Date: " +
              formatDate(d.date) +
              "<br/>" +
              "Party Vote: " +
              d.median +
              "%" +
              "<br/>" +
              "<small>" +
              d.poll +
              "</small>"
          )
          .style("left", currentEvent.pageX - 100 + "px")
          .style("top", currentEvent.pageY - 150 + "px");
      })
      .on("mouseout", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(500)
          .st("opacity", 1);

        d3
          .selectAll(".circles")
          .transition()
          .duration(500)
          .st("opacity", 0.2);

        this.tooltip
          .transition()
          .duration(100)
          .style("left", currentEvent.pageX - 100 + "px")
          .style("top", currentEvent.pageY - 150 + "px")
          .style("opacity", 0);
      });

    bindCircles.merge(enterCircles);
  }

  renderTrendLine5() {
    const { party_trend, line5, colorScale } = this.visComponents;

    const party_trends = this.trend5
      .selectAll("path")
      .data(party_trend.filter(d => d.latest < 3), d => d.party);

    party_trends
      .enter()
      .append("path")
      .at({
        class: d =>
          "line" + " party-" + d.party.replace(/\s/g, "").toLowerCase(),
        d: d => line5(d.values),
        stroke: d => colorScale(d.party)
      });
  }

  renderAxes5() {
    const { xScale, yScale5, innerH, innerW } = this.visComponents;

    const xAxis5 = d3
      .axisBottom(xScale)
      .tickSizeInner(0)
      .ticks(4);

    this.xAxis5.attr("transform", `translate(0, ${innerH + 10} )`).call(xAxis5);

    const yAxis5 = d3
      .axisLeft(yScale5)
      .tickSizeInner(-innerW)
      .tickFormat(d3.format(".0s"))
      .ticks(2);

    this.yAxis5.call(yAxis5);
  }

  renderSideLabels5() {
    const {
      xScale,
      yScale5,
      innerH,
      innerW,
      party_trend,
      colorScale
    } = this.visComponents;

    const label_data = party_trend.filter(d => d.latest < 3);

    this.g5
      .selectAll("text")
      .data(label_data, d => d.party)
      .enter()
      .append("text")
      .at({
        d: d => d.party,
        x: d => xScale(d.date) + 4,
        y: d => yScale5(d.latest),
        fill: d => colorScale(d.party),
        "font-family": "sans-serif",
        "font-size": "11px",
        class: "party-name"
      })
      .text(d => d.party)
      .on("mouseover", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(100)
          .st("opacity", 0.1);
        d3
          .selectAll(".circles")
          .transition()
          .duration(100)
          .st("opacity", 0.05);

        d3
          .selectAll(".line.party-" + d.party.replace(/\s/g, "").toLowerCase())
          .transition()
          .duration(1000)
          .st("opacity", 1);

        d3
          .selectAll(
            ".circles.party-" + d.party.replace(/\s/g, "").toLowerCase()
          )
          .transition()
          .duration(1000)
          .st("opacity", 0.4);
      })
      .on("mouseout", d => {
        d3
          .selectAll(".line")
          .transition()
          .duration(500)
          .st("opacity", 1);

        d3
          .selectAll(".circles")
          .transition()
          .duration(500)
          .st("opacity", 0.2);
      });
  }


  render() {
    const { height, width } = this.props;
    return (
      <div className="trend-chart">
        <div className="tc1">
          <h4 className="header">Party vote trends</h4>
          <p className="explainer">
            The Herald forecast model takes poll results for the last 12 months
            and previous elections since 1999 to predict party vote. A single
            poll does not have a huge impact on the model. Each poll for the
            last year is shown below, in comparison to the predictions.
            Hover/tap to see values for individual polls.
          </p>
          <svg
            id="trend-chart"
            ref={svg => {
              this.svg = svg;
            }}
            height={height}
            width={width}
          />
          <Share
            chart="trend-chart"
            desc="Herald election model predicts Labour overtaking National"
          />
          <small className="note">* Parties predicted to get above 5%</small>
        </div>

        <div className="tc2">
          <h4 className="header">Trend for parties polling below 5%</h4>

          <p className="explainer">
            Parties polling below 5 per cent are subject to more volatility in
            predictions as well. These are split into a separate visualisation
            below. There are no predictions for The Opportunities Party because
            of scarce polling data.
          </p>

          <svg
            id="trend-chart-fivepc"
            className="five-percent"
            ref={svg => {
              this.svg2 = svg;
            }}
            height={height}
            width={width}
          />
          <Share
            chart="trend-chart-fivepc"
            desc="Herald election model trend for parties polling below 5%"
          />
        </div>
      </div>
    );
  }
}

export default TrendChart;



// WEBPACK FOOTER //
// ./src/components/TrendChart/TrendChart.js